// extracted by mini-css-extract-plugin
export default {"header":"QUZOPJYdwt3jTkV42rFS","headerBadge":"Wg64hHQ54MJyl8PQiI4x","heading":"cWMRjMrzIfUWFBgwQxI3","issueDetails":"L0oujGWIYDSS1r_ow4kG","resolvedReason":"RDgaFLk8w3xUBnhxIAgh"};